import { useEffect, useState } from 'react'
import cx from 'classnames'

import Styles from './Card.module.scss'
import { Workspace } from 'types'
import { GithubIntegrationService } from 'api/services/GithubIntegrationService'

import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { WorkspaceClient } from 'api/clients/WorkspaceClient'
import { FormatMenu } from './FomatMenu'
import { renderFallbackThumbnail } from './utils'

interface Props {
  attrs: { [key: string]: string | number }
  selected: boolean
  workspace?: Workspace
  readOnly?: boolean
}

export const Card = ({ attrs, selected, workspace, readOnly }: Props) => {
  const [fetchedMetadata, setFetchedMetadata] = useState<{
    private?: boolean
    provider?: string
    status?: string
    title?: string
    author?: string
  }>({})

  const renderFormatMenu = () => {
    return <FormatMenu attrs={attrs} />
  }

  useEffect(() => {
    if (!workspace || !workspace.github_integration_enabled) return

    const fetchGithubMetadata = async () => {
      const { organization, endpoint, resourceId } = GithubIntegrationService.parseResourceUrl(attrs.url as string)

      const response = await WorkspaceClient.fetchGithubResourceMetadata(
        workspace.id,
        organization,
        endpoint,
        resourceId,
      )

      if (response?.type === SUCCESS_RESPONSE_TYPE) {
        setFetchedMetadata(response.data)
      }
    }

    switch (attrs.provider) {
      case 'github.com':
        fetchGithubMetadata()
        break

      default:
        break
    }
  }, [workspace, attrs])

  return (
    <>
      <div className={cx(Styles.cardContainer, { [Styles.selected]: selected })}>
        {selected && !readOnly && <>{renderFormatMenu()}</>}

        {!selected && !readOnly && <div className={cx(Styles.containerOverlay)}></div>}
        <div className={Styles.wrapper}>
          <div className={Styles.thumbnailContainer}>
            {attrs.thumbnailUrl && (
              <img src={attrs.thumbnailUrl as string} alt="thumbnail" className={Styles.cardImage} />
            )}

            {!attrs.thumbnailUrl && (
              <div className={Styles.fallbackIcon}>{renderFallbackThumbnail(attrs.provider as string)}</div>
            )}
          </div>

          <div className={Styles.textContainer}>
            <a href={attrs.url as string} target="_blank" rel="noreferrer noopener" className={Styles.cardHeading}>
              {fetchedMetadata?.title || attrs.url}
            </a>

            {fetchedMetadata?.author && <span className={Styles.author}>{fetchedMetadata?.author}</span>}

            <a href={attrs.url as string} target="_blank" rel="noreferrer noopener" className={Styles.cardUrl}>
              {attrs.url}
            </a>

            {attrs.description && <p>{attrs.description}</p>}
          </div>
        </div>
      </div>
    </>
  )
}
